// Mirrors backend tiers: free(0) < individual(1) < family(2) < premium elite(3)
export const FEATURE_TIER = {
  coaches: 1, wellness: 1, cycle: 1, passport: 1, wearables: 1,
  leaderboard: 1, challenges: 1, community: 1, family: 2,
};
export const TIER_LABEL = { 0: "Free", 1: "Individual", 2: "Family", 3: "Premium Elite" };
export const FEATURE_NAMES = {
  coaches: "AI Coaches", wellness: "Wellness Suite", cycle: "Cycle & Daily Edge",
  passport: "Travel Passport", wearables: "Wearables & Strava", leaderboard: "Leaderboard",
  challenges: "Challenges", community: "Community", family: "Family Plan",
};
export const tierOf = (m) => m?.tier ?? 0;
export const hasFeature = (m, f) => tierOf(m) >= (FEATURE_TIER[f] || 0);
export const requiredTierLabel = (f) => TIER_LABEL[FEATURE_TIER[f] || 1];
